export default __webpack_public_path__ + "images/0xec13336bbd50790a00cdc0feddf11287eaf92529.png";